<template>
	<div
		class="text-label-tertiary relative z-9 flex h-10 w-full items-center justify-center gap-2 px-4 py-2 text-sm font-medium uppercase"
	>
		<slot />
	</div>
</template>
